<template>
  <div
    class="modal-wrapper modal-wrapper--stretch-vertical"
    ref="modal-wrapper"
  >
    <div class="episodes cardboard">
      <button
        class="episodes__close"
        @click="close"
        aria-label="close"
        role="button"
      >
        <CloseAnimation />
      </button>

      <p class="episodes__title">The Asheville Sessions</p>

      <div class="episodes__section" v-for="item in data" :key="item.id">
        <YoutubeEmbed v-if="item.youtube" :id="item.youtube" />
        <div v-else>
          <div class="episodes__image-wrapper">
            <p>{{ item.date }}</p>
            <img
              :src="`episodes/${item.image}`"
              :alt="`Episode ${item.id} Image`"
            />
          </div>
        </div>

        <!-- <p class="episodes__episode">Episode {{ item.id }}</p> -->

        <p class="episodes__episode-title">{{ item.title }}</p>

        <p class="episodes__episode-text">{{ item.text }}</p>
      </div>

      <button class="content__back" @click="close">
        Explore the Polaroids
        <span><ButtonAnimation /></span>
      </button>
    </div>
  </div>
</template>

<script>
import YoutubeEmbed from "./YoutubeEmbed.vue";
import CloseAnimation from "@/components/animations/CloseAnimation.vue";
import ButtonAnimation from "@/components/animations/ButtonAnimation.vue";

export default {
  props: ["data"],
  components: {
    YoutubeEmbed,
    CloseAnimation,
    ButtonAnimation,
  },
  mounted() {
    this.$refs["modal-wrapper"].addEventListener("click", (e) => {
      const isOutside = !e.target.closest(".episodes");
      if (isOutside) this.close();
    });
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>
